import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';
import { ENDPOINT_ANALYSIS } from './constants';

export function useAnalysisService() {
  const { backendGet } = Sebrae.useBackend();

  const getAnalysisService = React.useCallback(
    (id) => backendGet(`${ENDPOINT_ANALYSIS}/${id}`),
    [backendGet],
  );

  return { getAnalysisService };
}
